import i18next from "i18next";
import languageDetector from "i18next-browser-languagedetector";
import { difference, isEqual, keys } from "lodash";
import { initReactI18next } from "react-i18next";
import { LocalesType } from "../constants/globals";
import en from "../locales/en";
import fa from "../locales/fa";
import { flattenKeys, isDevMod } from "./utils";
import { STORAGE_LANG } from "../constants/localstorage";

i18next
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      fa: {
        translation: fa,
      },
    },
    detection: {
      order: ["localStorage"],
    },
    fallbackLng: LocalesType["FA"],
    saveMissing: true,
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    changeHtmlLang();
  });

export const changeHtmlLang = (): void => {
  const languages: Array<string> = [...Object.values(LocalesType)];
  if (localStorage.getItem(STORAGE_LANG) && !languages.includes(localStorage.getItem(STORAGE_LANG) as string)) {
    changeI18nLocale(LocalesType.FA);
  }
  document.querySelector("html")?.setAttribute("lang", LocalesType["FA"]);
};

export const changeI18nLocale = (lang: LocalesType): void => {
  if (i18next.language !== lang) {
    i18next.changeLanguage(lang).then(() => {
      window.location.reload();
    });
  }
};

if (isDevMod) {
  const a = keys(flattenKeys(en));
  const b = keys(flattenKeys(fa));
  if (!isEqual(a, b)) {
    throw new Error(`
      Missed fa locales: [${difference(a, b)}]
      Missed en locales: [${difference(b, a)}]
    `);
  }
}

export const direction = [LocalesType["FA"], LocalesType["AR"]].includes(i18next.language as LocalesType) ? "rtl" : "ltr";
